// extracted by mini-css-extract-plugin
module.exports = {"panel":"NavPanel_panel__KcRE5","root":"NavPanel_root__Jrbg3","active":"NavPanel_active__l82I0","noTransition":"NavPanel_noTransition__Xm5tK"};